/**
 * Environment and configuration related type definitions
 *
 * This file contains all interfaces related to environment configuration,
 * AWS services configuration, and application settings.
 */

/**
 * AWS Cognito configuration interface
 * Used for authentication setup and token management
 */
export interface CognitoConfig {
  userPoolId: string;
  userPoolWebClientId: string;
  identityPoolId: string;
  domain: string;
  authRoleARN: string;
  unAuthRoleARN: string;
}

/**
 * Application monitoring configuration interface
 * Used for RUM, logging, and metrics services
 */
export interface MonitoringConfig {
  rumAppMonitorId: string;
  loggerUrl: string;
  metricsUrl: string;
}

/**
 * Build and deployment information interface
 * Contains metadata about the current build and deployment
 */
export interface BuildInfo {
  buildTime: string;
  stage: string;
  region: string;
  awsAccountId: string;
}

/**
 * AWS configuration interface
 * Basic AWS service configuration
 */
export interface AwsConfig {
  region: string;
  accountId: string;
}

export enum eGraphQLAuthMode {
  API_KEY = 'apiKey',
  USER_POOL = 'userPool',
}

export enum DevSecretKeys {
  GRAPHQL_ENDPOINT = 'graphql_endpoint',
  API_KEY = 'api_key',
}
